import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useAuth } from "../components/AuthContext";
import axios from "axios";
import { API_BASE } from "../apiBase";

const API = API_BASE;

export default function PaymentSuccessPage() {
    const [searchParams] = useSearchParams();
    const sessionId = searchParams.get("session_id");
    const isGuest = searchParams.get("guest") === "1";
    const { checkAuth, user } = useAuth();
    const navigate = useNavigate();
    const [status, setStatus] = useState("checking");
    const [plan, setPlan] = useState(null);
    const [attempts, setAttempts] = useState(0);

    useEffect(() => {
        if (!sessionId) { setStatus("error"); return; }

        const poll = async () => {
            try {
                const endpoint = isGuest
                    ? `${API}/api/subscription/status-guest/${sessionId}`
                    : `${API}/api/subscription/status/${sessionId}`;
                const { data } = await axios.get(endpoint, { withCredentials: true });
                if (data.payment_status === "paid") {
                    setStatus("success");
                    setPlan(data.plan);
                    if (isGuest && data.set_password_token) {
                        // Redirect guest to set password immediately
                        setTimeout(() => navigate(`/set-password?token=${data.set_password_token}`), 2000);
                    } else if (!isGuest && user) {
                        await checkAuth();
                        const isApi = data.plan === "api";
                        setTimeout(() => navigate(isApi ? "/developer" : "/positioning"), isApi ? 4000 : 2000);
                    }
                } else if (attempts >= 5) {
                    setStatus("timeout");
                } else {
                    setAttempts((a) => a + 1);
                    setTimeout(poll, 2000);
                }
            } catch {
                setStatus("error");
            }
        };
        poll();
    }, [sessionId]); // eslint-disable-line react-hooks/exhaustive-deps

    const isApi = plan === "api";

    return (
        <div style={{
            minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
            background: "var(--pord-bg, #1a1e14)", fontFamily: "'DM Sans', sans-serif", color: "#DAF2D0",
        }}>
            <div style={{ textAlign: "center", maxWidth: 440 }}>
                {status === "checking" && <p style={{ fontSize: 16 }}>Verifying payment...</p>}
                {status === "success" && isGuest && (
                    <>
                        <h2 style={{ fontSize: 24, fontWeight: 300, marginBottom: 12 }}>
                            {isApi ? "API Access Confirmed" : "Payment Successful"}
                        </h2>
                        <p style={{ fontSize: 13, color: "rgba(255,255,255,0.5)", marginBottom: 8, lineHeight: 1.6 }}>
                            Setting up your account — redirecting to create your password...
                        </p>
                    </>
                )}
                {status === "success" && !isGuest && !isApi && (
                    <>
                        <h2 style={{ fontSize: 24, fontWeight: 300, marginBottom: 8 }}>Payment Successful</h2>
                        <p style={{ fontSize: 13, color: "rgba(255,255,255,0.5)" }}>Redirecting to dashboard...</p>
                    </>
                )}
                {status === "success" && !isGuest && isApi && (
                    <>
                        <h2 style={{ fontSize: 24, fontWeight: 300, marginBottom: 12 }}>API Access Confirmed</h2>
                        <p style={{ fontSize: 13, color: "rgba(255,255,255,0.5)", marginBottom: 8, lineHeight: 1.6 }}>
                            Your API access is being set up. You will receive your API key via email shortly.
                        </p>
                        <p style={{ fontSize: 12, color: "rgba(255,255,255,0.35)" }}>Redirecting to developer docs...</p>
                    </>
                )}
                {status === "timeout" && <p style={{ fontSize: 14 }}>Payment still processing. Please check back shortly.</p>}
                {status === "error" && <p style={{ fontSize: 14, color: "#e57373" }}>Error verifying payment. Please contact support.</p>}
            </div>
        </div>
    );
}
